import { getViewMode } from '../state/site/selectors';
import { VIEW_MODE_EDITOR } from '../constants/view-modes';

const BASE_URL = '/_api/settings';
const SETTINGS_DEBOUNCE_TIME = 220;

export const RECEIVED_GLOBAL_SETTINGS = 'RECEIVED_GLOBAL_SETTINGS';

export const RECEIVED_COMPONENT_SETTINGS = 'RECEIVED_COMPONENT_SETTINGS';

export const MERGE_GLOBAL_SETTING_IN_STORE = 'MERGE_GLOBAL_SETTING_IN_STORE';

export const MERGE_COMPONENT_SETTING_IN_STORE = 'MERGE_COMPONENT_SETTING_IN_STORE';

export const receivedGlobalSettings = (payload) => ({
  type: RECEIVED_GLOBAL_SETTINGS,
  payload,
});

export const receivedComponentSettings = (payload) => ({
  type: RECEIVED_COMPONENT_SETTINGS,
  payload,
  meta: {
    debounce: {
      time: SETTINGS_DEBOUNCE_TIME,
    },
  },
});

export const mergeGlobalSettingInStore = (payload) => ({
  type: MERGE_GLOBAL_SETTING_IN_STORE,
  payload,
});

export const simpleMergeComponentSettingInStore = (payload) => ({
  type: MERGE_COMPONENT_SETTING_IN_STORE,
  payload,
});

export const mergeComponentSettingInStore = (payload) => (dispatch, getState) => {
  const viewMode = getViewMode(getState());
  const mergeAction = simpleMergeComponentSettingInStore(payload);

  try {
    if (viewMode === VIEW_MODE_EDITOR) {
      dispatch({ ...mergeAction, meta: { debounce: { time: SETTINGS_DEBOUNCE_TIME } } });
    } else {
      dispatch(mergeAction);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
};

export const fetchGlobalSettings = (viewMode) => (dispatch, getState, { request }) =>
  request(`${BASE_URL}/global?viewMode=${viewMode}`).then((settings) => dispatch(receivedGlobalSettings(settings)));

export const fetchComponentSettings = (appComponent, compId, viewMode, originCompId = null) => (
  dispatch,
  getState,
  { request },
) =>
  request(
    `${BASE_URL}/component?viewMode=${viewMode}&compId=${compId}&appComponent=${appComponent}&originCompId=${originCompId}`,
  ).then((settings) => dispatch(receivedComponentSettings(settings)));

export const mergeGlobalSetting = (viewMode, setting) => (dispatch, getState, { request }) => {
  dispatch(mergeGlobalSettingInStore(setting));
  return request
    .put(`${BASE_URL}/merge/global?viewMode=${viewMode}`, setting)
    .then(() => dispatch(fetchGlobalSettings(viewMode)));
};

export const mergeComponentSetting = (appComponent, compId, viewMode, setting) => (dispatch, getState, { request }) => {
  dispatch(mergeComponentSettingInStore(setting));
  return request
    .put(`${BASE_URL}/merge/component?appComponent=${appComponent}&compId=${compId}&viewMode=${viewMode}`, setting)
    .then(() => dispatch(fetchComponentSettings(appComponent, compId, viewMode)));
};
